export const SYSTEM_FONT_STACK =
  '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Ubuntu, "Open Sans", "Helvetica Neue", Arial, sans-serif';

export const FONT_MAP = {
  system: SYSTEM_FONT_STACK,
  "volvo-novum": `"Volvo Novum", ${SYSTEM_FONT_STACK}`,
  "mazda-type": `"Mazda Type", ${SYSTEM_FONT_STACK}`,
  "bmw-type-next": `"BMW Type Next", ${SYSTEM_FONT_STACK}`,
  "hyundai-sans": `"Hyundai Sans Text Office", ${SYSTEM_FONT_STACK}`,
  "genesis-sans": `"GenesisSans Text KR", ${SYSTEM_FONT_STACK}`,
  "helvetica-neue-lt": `"Helvetica Neue LT Std", "Helvetica Neue", Helvetica, ${SYSTEM_FONT_STACK}`,
  "miller-banner": `"Miller Banner", Georgia, ${SYSTEM_FONT_STACK}`,
};

const volvoDealerLocationIds = ["6745aad38f06faf6a6ca13ef"];
const mazdaDealerLocationIds = [
  "68e6ab5f1f288d6e844e77b9",
  "69246047c84bcb057d926de3",
];

export const getFontFamily = (chatData) => {
  if (!chatData) return SYSTEM_FONT_STACK;

  if (chatData.fontFamily && FONT_MAP[chatData.fontFamily]) {
    return FONT_MAP[chatData.fontFamily];
  }

  const token = chatData._token;
  const id = chatData._location_id;

  if (volvoDealerLocationIds.includes(id)) {
    return "Volvo Novum";
  }

  if (
    token === "12423abb841941c552815dac59ee48477267ec50" ||
    token === "489734309b0baf97129d98198f67cf878bacbb85" ||
    token === "25e67694cd84d6cb8471cd7b765077c14315a923" ||
    token === "aeb87d7628e0145574fec7667902769095eab957"
  ) {
    // MAT-3739
    return "Arial";
  }

  return SYSTEM_FONT_STACK;
};

export const getLocationStyles = (locationId, fontFamily) => {
  const styles = {
    fontFamily: SYSTEM_FONT_STACK,
  };

  if (fontFamily && FONT_MAP[fontFamily]) {
    styles.fontFamily = FONT_MAP[fontFamily];
    if (fontFamily === "mazda-type") {
      styles.letterSpacing = "2px";
    }
    return styles;
  }

  // Volvo dealers
  if (volvoDealerLocationIds.includes(locationId)) {
    styles.fontFamily =
      'Volvo Novum, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif';
  }

  // BMW dealers
  if (
    locationId === "67780f5e3fd6d546a196f570" ||
    locationId === "669e73689bbbd1bad1b06a61" // stg test
  ) {
    styles.fontFamily = '"BMW Type Next", sans-serif';
  }

  // Mazda dealers
  if (mazdaDealerLocationIds.includes(locationId)) {
    styles.fontFamily = '"Mazda Type", sans-serif';
    styles.letterSpacing = "2px";
  }

  return styles;
};
